export const S3_CONFIG = {
  region: "us-east-1",
  bucket: "netjer-intranet-docgen-proyectos",
  credentials: {
    accessKeyId: "AKIA2O5KPPW4W5BHBSXF",
    secretAccessKey: "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",
  },
};
